import * as Yup from "yup";
const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
const PhoneNumberSchema = Yup.string().required("Please enter your phone number").matches(phoneRegExp, "Must be a valid phone number");
export {
  PhoneNumberSchema as P
};
//# sourceMappingURL=phone-number-schema-DfpW0Nhe.js.map
